<template>
  <div class="content c895">
    <h2>Tiskalnik 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev11" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Tiskalnik</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev11&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Tiskalnik</td>
            <td>Brizgalni tiskalnik za domačo uporabo</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev11&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="T">Tiskalnik</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            12,25 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">0,92 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Tiskalnik</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore active" style="cursor:pointer;">Izklapljamo iz vtičnice</a>

          <div style class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>10 % električne energije pri uporabi tiskalnika privarčujemo, če tiskalnik izključimo iz električnega omrežja, ko ga dlje časa ne potrebujemo.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Namestimo centralni tiskalnik</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>50 % električne energije pri uporabi tiskalnika privarčujemo, če v primeru, ko uporabljamo več samostojnih tiskalnikov, namesto njih namestimo centralni tiskalnik.</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Na porabo vaše naprave vplivajo različni dejavniki, od energetskega razreda do načina, kako jo uporabljate. Preberite dodatne nasvete, kako znižati porabo električne energije v vašem gospodinjstvu.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/tiskalnik"
        target="_blank"
        alt="več"
        class="more"
      >Preberite si več nasvetov</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE TISKALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">0,92 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE TISKALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000007.png?b85770ac-235d-4366-ad24-25f7132f7ec7"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 17, 119, 17, 119, 17, 144, 257, 144"
              title="13.11.2021; 0,9247328272"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 43, 197, 43, 257, 18, 257, 18, 257, 144, 197, 144"
              title="13.11.2025; 4,623664136"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 68, 137, 68, 197, 43, 197, 43, 197, 144, 137, 144"
              title="13.11.2024; 3,6989313088"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 93, 77, 93, 137, 68, 137, 68, 137, 144, 77, 144"
              title="13.11.2023; 2,7741984816"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 119, 17, 119, 77, 93, 77, 93, 77, 144, 17, 144"
              title="13.11.2022; 1,8494656544"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>